/**
 * 运行时诊断中心：收集告警、错误与自动修复记录。
 * 内核不依赖 React；网页端通过 snapshot() 展示。
 */

let sequence = 0;

export class DiagnosticsCenter {
  constructor({ limit = 120 } = {}) {
    this.limit = limit;
    this.entries = [];
    this.listeners = new Set();
    this.counters = { info: 0, warning: 0, error: 0, repair: 0 };
  }

  /**
   * @param {'info'|'warning'|'error'|'repair'} level
   * @param {string} title
   * @param {{ code?: string, detail?: string, action?: string, meta?: object }} [options]
   */
  report(level, title, options = {}) {
    sequence += 1;
    const entry = {
      id: `diag-${sequence}`,
      level,
      title,
      code: options.code ?? 'GENERAL',
      detail: options.detail ?? '',
      action: options.action ?? '',
      meta: options.meta ?? null,
      at: new Date().toISOString(),
      wallClock: typeof performance !== 'undefined' ? performance.now() : Date.now(),
    };
    this.entries.push(entry);
    if (this.entries.length > this.limit) this.entries.shift();
    this.counters[level] = (this.counters[level] ?? 0) + 1;
    for (const listener of this.listeners) {
      try {
        listener(entry);
      } catch {
        // 诊断订阅器自身出错时不得影响仿真。
      }
    }
    return entry;
  }

  info(title, options) {
    return this.report('info', title, options);
  }

  warn(title, options) {
    return this.report('warning', title, options);
  }

  error(title, options) {
    return this.report('error', title, options);
  }

  repair(title, options) {
    return this.report('repair', title, options);
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  clear() {
    this.entries = [];
    this.counters = { info: 0, warning: 0, error: 0, repair: 0 };
  }

  snapshot() {
    return this.entries.map((entry) => ({ ...entry }));
  }
}
